import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 5FA4943E-5956-4668-ADDD-984914DD745C
 * name chart-sankey-variant
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-sankey-variant.svg
 * tags
 * - Math 
 */
export const ChartSankeyVariantIcon = createSvgIcon(<><path d="M20 4V6H4V4H2V12H4V10C8.16 10 9.92 12.11 11.77 14.34S15.65 19 20 19V21H22V15H20V17C16.59 17 15.07 15.17 13.31 13.06C11.34 10.69 9.1 8 4 8H20V10H22V4Z" /></>, 'ChartSankeyVariantIcon');
export default ChartSankeyVariantIcon